import TrendingSearches from './TrendingSearches'

export default TrendingSearches
